import { render } from "./JournalVoucher.vue?vue&type=template&id=1a03c9f9&scoped=true&ts=true"
import script from "./JournalVoucher.vue?vue&type=script&lang=ts"
export * from "./JournalVoucher.vue?vue&type=script&lang=ts"

import "./JournalVoucher.vue?vue&type=style&index=0&id=1a03c9f9&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a03c9f9"]])

export default __exports__